import { graphql } from "gql.tada";

const UserDataQry = graphql(`
  query currentUser {
    currentUser {
      id
      fullName
      email
      tenant
      currencyCode
    }
  }
`);

export { UserDataQry };
